/**
 * client-view App (U15) — route dispatch for the public document surface:
 * proposal viewer, sub invite claim, and the Puppeteer /print target.
 * Each screen is its own URL; there is no client-side navigation.
 */
import React, { useMemo } from 'react';

import { parseRoute } from './router';
import { ChangeOrderPage } from './pages/ChangeOrderPage';
import { InvitePage } from './pages/InvitePage';
import { JoinCodePage } from './pages/JoinCodePage';
import { JoinPage } from './pages/JoinPage';
import { MissingPage } from './pages/MissingPage';
import { PrintPage } from './pages/PrintPage';
import { ProposalPage } from './pages/ProposalPage';

export function App(): JSX.Element {
  const route = useMemo(
    () => parseRoute(window.location.pathname, window.location.search),
    [],
  );

  switch (route.kind) {
    case 'proposal':
      return <ProposalPage token={route.token} />;
    case 'invite':
      return <InvitePage token={route.token} />;
    case 'changeOrder':
      return <ChangeOrderPage token={route.token} />;
    case 'join':
      return <JoinPage token={route.token} />;
    case 'joinCode':
      return <JoinCodePage />;
    case 'print':
      return <PrintPage session={route.session} />;
    case 'missing':
      return <MissingPage />;
  }
}
